exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://use.typekit.net/srv0wme.css);", ""]);

// module
exports.push([module.id, "/*\r\n$breakpoint argument choices:\r\n- xs\r\n- sm\r\n- md\r\n- lg\r\n- xl\r\n*/\n.resource-container[data-v-6f2bf545] {\n  border: 2px solid #cccccc;\n  border-radius: 1em;\n  padding: 5px;\n  margin-bottom: 2em;\n}\n.resource-container .section-title[data-v-6f2bf545] {\n    font-size: 1.5em;\n    text-transform: uppercase;\n    text-decoration: underline;\n    text-align: center;\n}\n", ""]);

// exports
